export default __webpack_public_path__ + "static/media/temp_4.0c354e0a.png";